module.exports = "mutation UpdateStoreComment($comment:UpdateStoreCommentInput!){updateComment:updateStoreComment(data:$comment){success}}"